export default "__VITE_ASSET__Bj3EoCNz__"